import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/ArrowRight.svg'

export const IconArrowRight = IconSVG as IconComponent
